import { createAction, props } from '@ngrx/store';

export const setTaxAction = createAction(
  '[COIN] Set TAX',
  props<{ tax: number }>()
);